<script setup>
import { ref } from 'vue'

const props = defineProps({
  title: { type: String, default: '' },
  open: { type: Boolean, default: false }
})

// Local reactive open state. SSR renders the initial markup (with .open when
// props.open is true); on the client the header button toggles it.
const isOpen = ref(props.open)
function toggle() { isOpen.value = !isOpen.value }
</script>

<template>
  <div class="faq-item" :class="{ open: isOpen }">
    <button class="faq-q" type="button" :aria-expanded="isOpen" @click="toggle">
      {{ title }}
      <svg class="fic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 5v14M5 12h14" stroke-linecap="round" />
      </svg>
    </button>
    <div class="faq-a">
      <div class="faq-a-in">
        <slot />
      </div>
    </div>
  </div>
</template>
